import React, { useCallback, useEffect, useLayoutEffect, useMemo, useState } from "react";
import { Box } from "@material-ui/core";
import { Link } from "react-router-dom";
import clsx from "classnames";

import ButtonSmg from "../ButtonSmg";
import LinkEcco, { WrappedLinkRouter } from "../Link";
import HeaderMenu from "../HeaderMenu";

import { useStyles } from "../../hooks";
import styles from "./styles";

import moment from 'moment';
import { PUBLICURL } from "../../main_config";
import menuItems from "../../data/menu_links";

import { useHistory, useLocation } from "react-router-dom";
import ImportantMessageDialog from "../ImportantMessageDialog";
import EmergencyCallDialog from "../EmergencyCallDialog";
import { cotizadorPathFromLocation } from "../../routes/paths";

const Header = () => {
  const classes = useStyles(styles);
  const [openMenuKey, setOpenMenuKey] = useState(null);
  const [highlightMenuKey, setHighlightMenuKey] = useState(null);
  const [megaLeft, setMegaLeft] = useState(40);
  const [callDialogOpen, setCallDialogOpen] = useState(false);
  const history = useHistory();
  const { pathname } = useLocation();
  const cotizadorTo = cotizadorPathFromLocation(pathname);

  const openMenuItem = useMemo(
    () => menuItems.find(menu => menu.key === openMenuKey && menu.static),
    [openMenuKey]
  );

  useEffect(() => {
    setOpenMenuKey(null);
    setHighlightMenuKey(null);
  }, [pathname]);

  const handleOpenMenu = useCallback(key => {
    setOpenMenuKey(key);
    if (key) {
      setHighlightMenuKey(key);
    }
  }, []);

  const handleSelectNav = useCallback(key => {
    setOpenMenuKey(null);
    setHighlightMenuKey(key);
  }, []);

  const syncMegaLeft = useCallback(() => {
    if (!openMenuKey) return;
    const btn = document.getElementById(`btn-header-${openMenuKey}`);
    if (!btn) return;
    setMegaLeft(Math.max(40, Math.round(btn.getBoundingClientRect().left)));
  }, [openMenuKey]);

  useLayoutEffect(() => {
    syncMegaLeft();
  }, [syncMegaLeft]);

  useEffect(() => {
    if (!openMenuKey) return undefined;
    window.addEventListener("resize", syncMegaLeft);
    return () => window.removeEventListener("resize", syncMegaLeft);
  }, [openMenuKey, syncMegaLeft]);

  const renderLinks = () => {
    return (
      <Box
        display="flex"
        justifyContent="flex-start"
        className={classes.eccoLinks}
      >
        {
          menuItems.filter(menu => !menu.cta)
            .map(menu => (
              <HeaderMenu
                key={menu.key}
                item={menu}
                openMenuKey={openMenuKey}
                highlightMenuKey={highlightMenuKey}
                onOpenMenu={handleOpenMenu}
                onSelectNav={handleSelectNav}
              />
            ))
        }
      </Box>
    );
  };

/***************************************************************
Validación de fecha que se mostrará en los días definidos
***************************************************************/
  
const [openVO, setOpenVO] = useState(false);
const [redirectPath, setRedirectPath] = useState(""); // Guarda la URL de destino


 const handleOpenAsociarme  = () => {
  const now = moment();

  const startDate = moment("2025-06-20T00:00:00");
  const endDate = moment("2025-06-20T20:00:00");

  if (now.isBetween(startDate, endDate, null, "[]")) {
    setOpenVO(true);
    setRedirectPath("");
  } else {
    history.push(cotizadorTo);
  }
};

const handleCloseVO = () => {
  setOpenVO(false);
  if (redirectPath) {
    history.push(redirectPath); // Solo redirige si hay una ruta establecida
    setRedirectPath(""); // Resetea para evitar redirecciones no deseadas
  }
}; 

/***************************************************************
Fin validación de fecha que se mostrará en los días definidos
***************************************************************/


  return (
    <Box className={classes.root}>
      <Box className={classes.contentWrap}>
        <Box className={classes.topbar} component="div">
          <Box className={classes.backerPill}>
            <img
              className={classes.backerLogo}
              src={`${PUBLICURL}/assets/images/home/logo-swiss-medical.svg`}
              alt=""
              width={45}
              height={11}
            />
            <p className={classes.backerText}>Respaldado por Swiss Medical</p>
          </Box>
          <Box className={classes.topbarRight}>
            <button
              type="button"
              className={classes.emergency}
              onClick={() => setCallDialogOpen(true)}
              aria-label="Llamar a emergencias 0810-333-3226"
            >
              <span className={classes.emergencyDot} aria-hidden="true" />
              <span className={classes.emergencyLabel}>Emergencias</span>
              <span className={classes.emergencyPhone}>0810-333-3226</span>
            </button>
            <LinkEcco url={`${PUBLICURL}/login#/`} className={classes.loginLink} underline="none">
              <img
                className={classes.loginIcon}
                src={`${PUBLICURL}/assets/images/header/icon-user.svg`}
                alt=""
                width={15}
                height={15}
              />
              Ingresá a Mi ECCO
            </LinkEcco>
          </Box>
        </Box>
        <Box
          display="flex"
          alignItems="center"
          className={classes.headerContainer}
        >
          <Box className={classes.headerLeft}>
            <LinkEcco to="/" className={classes.eccoLogo}>
              <img
                src={`${PUBLICURL}/assets/images/header/logo-ecco.png`}
                alt="Ecco"
                className={classes.logo}
                width={103}
                height={34}
              />
            </LinkEcco>
            {renderLinks()}
          </Box>
          <Box className={classes.eccoButtonsContainer}>
            <ButtonSmg
              id="btn-asociarme"
              theme="material"
              color="primary"
              content="Asociate hoy"
              buttonNav
              className={classes.headerCta}
              component={WrappedLinkRouter}
              to={cotizadorTo}
              target="_self"
              onClick={(e) => {
                e.preventDefault();
                handleOpenAsociarme();
              }} 
            />
          </Box>
        </Box>
      </Box>

      {openMenuItem && (
        <Box
          id={`mega-${openMenuItem.key}`}
          data-header-menu={openMenuItem.key}
          className={classes.megaMenu}
          role="menu"
          aria-label={openMenuItem.label}
        >
          <Box
            className={classes.megaMenuList}
            style={{ paddingLeft: megaLeft }}
          >
            {openMenuItem.elemens.map((elem, index) => (
              <Link
                key={elem.key}
                id={`menu-${elem.key}`}
                to={elem.to || `/${elem.key}`}
                role="menuitem"
                className={clsx(
                  classes.megaLink,
                  index === 0 &&
                    elem.label === "Servicios" &&
                    classes.megaLinkHeading
                )}
                onClick={() => handleOpenMenu(null)}
              >
                {elem.label}
              </Link>
            ))}
          </Box>
        </Box>
      )}

      <EmergencyCallDialog
        open={callDialogOpen}
        onClose={() => setCallDialogOpen(false)}
      />

      <ImportantMessageDialog open={openVO} onClose={handleCloseVO} />

    </Box>
  );
};

export default Header;
